interface PageTitleProps {
  initialized?: boolean;
  title?: any;
  topRightWidget?: any;
}

const PageTitle = ({
  initialized = true,
  title,
  topRightWidget,
}: PageTitleProps) => (
  <div style={{ display: 'flex', margin: '16px 0 8px' }}>
    <h2 style={{ flex: 1 }}>{title}</h2>
    <div style={{ alignItems: 'center', display: 'flex' }}>{initialized && topRightWidget}</div>
  </div>
);

export default PageTitle;
